import React from "react";
import { CreditTypeEnum } from "@entities/Product/Application/types";
import { CollateralCarFields } from "@entities/Product/Application/ui/CollateralCarFields";
import { CollateralRealEstateFields } from "@entities/Product/Application/ui/CollateralRealEstateFields";

interface IProps {
  pledgeTypes: { value: string; label: string }[];
  states: { value: string; label: string }[];
  brandOptions: { value: string; label: string }[];
  productId: string;
}

export function Step5Fields({
  pledgeTypes,
  states,
  brandOptions,
  productId,
}: IProps) {
  return (
    <>
      {productId === CreditTypeEnum.PLEDGE_AUTO && (
        <CollateralCarFields brandOptions={brandOptions} />
      )}
      {productId === CreditTypeEnum.PLEDGE_REAL_ESTATE && (
        <CollateralRealEstateFields
          pledgeTypes={pledgeTypes}
          stateOptions={states}
        />
      )}
    </>
  );
}
